import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconLoudBell48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}>
            <path
                d="M46.1704 21.6612C45.2116 27.23 41.7633 31.9474 37.0125 34.626L36.041 32.8774C40.2749 30.4865 43.3472 26.2795 44.2004 21.3139L46.1704 21.6612Z"
                fill={props.foregroundcolor || 'black'}
            />
            <path
                d="M13.5508 10.4183C16.0237 6.02496 20.4505 2.87839 25.6527 2.15716L25.3637 0.177856C19.5329 0.990085 14.572 4.52005 11.8021 9.44682L13.5508 10.4183Z"
                fill={props.foregroundcolor || 'black'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.7619 12.8075C42.7145 10.8549 42.7145 7.68908 40.7619 5.73645C38.8093 3.78383 35.6434 3.78383 33.6908 5.73645C33.6701 5.75719 33.6496 5.77806 33.6293 5.79908C29.3673 4.21823 24.3875 5.14018 20.9628 8.56491L15.0949 14.4328C14.7738 14.7539 14.3529 14.9562 13.9016 15.0063L2.90331 16.2284C2.235 16.3026 1.61187 16.6021 1.1364 17.0776C-0.0200348 18.234 -0.0200348 20.109 1.1364 21.2654L8.94198 29.071C6.59883 31.4142 6.59883 35.2131 8.94198 37.5563C11.2851 39.8994 15.0841 39.8994 17.4273 37.5563L25.2328 45.3619C26.3893 46.5183 28.2642 46.5183 29.4207 45.3619C29.8961 44.8864 30.1956 44.2633 30.2699 43.595L31.4919 32.5967C31.5421 32.1453 31.7443 31.7245 32.0655 31.4034L37.9334 25.5355C41.3581 22.1108 42.28 17.1311 40.6992 12.8691C40.7203 12.8488 40.7411 12.8283 40.7619 12.8075ZM39.768 10.867C39.2557 10.0487 38.6441 9.27549 37.9335 8.56488C37.2228 7.85427 36.4497 7.24261 35.6314 6.73035C36.7901 6.00169 38.3388 6.1418 39.3477 7.15067C40.3565 8.15954 40.4966 9.70819 39.768 10.867ZM36.5191 24.1213L30.6513 29.9891C30.009 30.6314 29.6045 31.4731 29.5042 32.3758L28.2821 43.3741C28.258 43.591 28.1608 43.7933 28.0065 43.9477C27.6311 44.323 27.0224 44.323 26.647 43.9477L2.55062 19.8512C2.17522 19.4758 2.17522 18.8672 2.55062 18.4918C2.70496 18.3375 2.90723 18.2402 3.12417 18.2161L14.1224 16.9941C15.0252 16.8938 15.8669 16.4893 16.5091 15.847L22.377 9.97913C26.2822 6.07388 32.6139 6.07388 36.5191 9.97913C40.4244 13.8844 40.4244 20.216 36.5191 24.1213ZM16.013 36.1421L10.3562 30.4852C8.7941 32.0473 8.79409 34.58 10.3562 36.1421C11.9183 37.7042 14.451 37.7042 16.013 36.1421Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}

export function IconLoudBell24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}>
            <path
                d="M22.7026 12.9736C21.8928 15.4449 20.0975 17.4698 17.7812 18.5837L16.8325 16.8196C18.6833 15.9574 20.1241 14.3628 20.7824 12.4083L22.7026 12.9736Z"
                fill={props.foregroundcolor || 'black'}
            />
            <path
                d="M6.91685 6.7163C7.75632 4.99961 9.23153 3.65054 11.0358 2.97574L10.4435 1.06213C8.13924 1.89198 6.24785 3.58659 5.16092 5.75439L6.91685 6.7163Z"
                fill={props.foregroundcolor || 'black'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.04919 14.481L0.884453 11.3162C0.339487 10.7713 0.339487 9.88772 0.884455 9.34276C1.11314 9.11407 1.41416 8.97191 1.73605 8.94059L7.00068 8.42832C7.22945 8.40606 7.44358 8.3057 7.60705 8.14412L10.6824 5.10439C12.4651 3.34227 15.1197 3.00165 17.2395 4.07436C17.423 3.45325 17.9977 3.00001 18.6782 3.00001C19.5067 3.00001 20.1782 3.67158 20.1782 4.50001C20.1782 5.1025 19.823 5.62203 19.3106 5.86059C20.8931 8.08918 20.6749 11.1992 18.6677 13.1832L15.5914 16.2238C15.4287 16.3847 15.326 16.5966 15.3005 16.824L14.7279 21.9354C14.6925 22.2517 14.5506 22.5467 14.3255 22.7718C13.7772 23.3201 12.8883 23.3201 12.34 22.7718L9.22626 19.6581C9.19471 19.6769 9.16295 19.6952 9.13099 19.713C7.70143 20.5094 5.86248 20.3064 4.64009 19.0981C3.41771 17.8899 3.1934 16.0534 3.97314 14.6147C3.99751 14.5697 4.02286 14.5251 4.04919 14.481ZM7.19438 10.4189L3.20385 10.8072L12.8783 20.4816L13.3129 16.6014C13.3893 15.9193 13.6973 15.2839 14.1855 14.8014L17.2617 11.7608C18.7071 10.3321 18.7206 8.00231 17.2919 6.55701C15.8633 5.11176 13.5336 5.09824 12.0883 6.5268L9.01301 9.56654C8.52272 10.0512 7.8805 10.3522 7.19438 10.4189ZM7.56754 18.1676L5.53659 16.1601C5.45969 16.6981 5.62987 17.2643 6.04607 17.6757C6.46228 18.0871 7.03046 18.2507 7.56754 18.1676Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}

export function IconLoudBell16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.3136 3.75727C11.142 2.5857 9.24254 2.5857 8.07097 3.75727L5.94965 5.87859C5.83988 5.98837 5.70605 6.07108 5.55877 6.12017L2.85113 7.02272L9.04817 13.2198L9.95071 10.5121C9.99981 10.3648 10.0825 10.231 10.1923 10.1212L12.3136 7.99991C13.4852 6.82834 13.4852 4.92884 12.3136 3.75727ZM6.65676 2.34306C8.60938 0.390437 11.7752 0.390437 13.7278 2.34306C15.6804 4.29568 15.6804 7.4615 13.7278 9.41413L11.7734 11.3685L10.4339 15.3872C10.3243 15.716 10.0522 15.9646 9.71494 16.0442C9.37763 16.1239 9.02314 16.0232 8.77808 15.7781L0.292796 7.29281C0.0477283 7.04774 -0.052974 6.69325 0.0266535 6.35595C0.106281 6.01864 0.354882 5.74661 0.683674 5.63702L4.70236 4.29745L6.65676 2.34306Z"
                fill={props.foregroundcolor || 'black'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.41412 9.41413L3.12122 8.70702L4.53544 10.1212L3.82833 10.8283C3.43781 11.2189 3.43781 11.852 3.82833 12.2426C4.21885 12.6331 4.85202 12.6331 5.24254 12.2426L5.94965 11.5354L7.36386 12.9497L6.65676 13.6568C5.48518 14.8283 3.58569 14.8283 2.41412 13.6568C1.24254 12.4852 1.24254 10.5857 2.41412 9.41413Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}
